<div class="standard-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ 'CreateUser.CreateUserAccount' | translate }}</h2>
      <p class="subtitle">{{ 'CreateUser.Subtitle' | translate }}</p>
    </div>
  </div>

  <mat-dialog-content class="form-content">
    <form [formGroup]="createForm" (ngSubmit)="submit(createForm.value)" class="d-flex flex-column gap-3">
      <div class="w-100">
        <mat-label class="form-label mb-1">{{ 'CreateUser.FirstName' | translate }}</mat-label>
        <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
          <input matInput [placeholder]="'CreateUser.EnterFirstName' | translate" name="firstName" [formControl]="createForm.controls['firstName']" required />
        </mat-form-field>
      </div>

      <div class="w-100">
        <mat-label class="form-label mb-1">{{ 'CreateUser.LastName' | translate }}</mat-label>
        <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
          <input matInput [placeholder]="'CreateUser.EnterLastName' | translate" name="lastName" [formControl]="createForm.controls['lastName']" required />
        </mat-form-field>
      </div>

      <div class="w-100">
        <mat-label class="form-label mb-1">{{ 'CreateUser.Email' | translate }}</mat-label>
        <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
          <input matInput [placeholder]="'CreateUser.EnterEmail' | translate" name="email" [formControl]="createForm.controls['email']" required />
        </mat-form-field>
      </div>

      <div class="w-100">
        <mat-label class="form-label mb-1">{{ 'CreateUser.Type' | translate }}</mat-label>
        <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
          <mat-select name="type" [placeholder]="'Courses.ChunkCreator.SelectEditorType' | translate" [formControl]="createForm.controls['type']">
            @for (type of userTypes; track type) {
              <mat-option [value]="type.name">
                {{ type.displayName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <div class="left-actions"></div>
    <div class="right-actions d-flex gap-2">
      <button mat-button mat-dialog-close>{{ 'Global.Cancel' | translate }}</button>
      <button mat-flat-button color="primary" (click)="submit(createForm.value)" [disabled]="buttonLock || createForm.invalid">
        {{ 'CreateUser.Create' | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
